import { httpsCallable } from 'firebase/functions';
import { functions } from '@/lib/firebase';
import type {
  ProvisionTenantInput,
  ProvisionTenantResult,
  SupportSession,
  OpsCopilotFeedbackInput,
} from '@/types';

export const saasService = {
  async provisionTenant(input: ProvisionTenantInput): Promise<ProvisionTenantResult> {
    const fn = httpsCallable<ProvisionTenantInput, ProvisionTenantResult>(functions, 'provisionTenant');
    const res = await fn(input);
    return res.data;
  },

  async createSupportSession(targetTenantId: string, reason: string, durationHours = 2): Promise<SupportSession> {
    const fn = httpsCallable<{ targetTenantId: string; reason: string; durationHours?: number }, SupportSession>(
      functions,
      'createSupportSession'
    );
    const res = await fn({ targetTenantId, reason, durationHours });
    return res.data;
  },

  async closeSupportSession(sessionId: string): Promise<boolean> {
    const fn = httpsCallable<{ sessionId: string }, { success: boolean }>(functions, 'closeSupportSession');
    const res = await fn({ sessionId });
    return res.data.success;
  },

  async getTenantFinOps(tenantId: string, yearMonth?: string): Promise<{
    usage: any;
    revenueMonthlyBrl: number;
    aiCostUsd: number;
    aiCostBrl: number;
    estimatedGrossMarginBrl: number;
    marginPercentage: number;
    planId: string;
  }> {
    const fn = httpsCallable<{ tenantId: string; yearMonth?: string }, any>(functions, 'getTenantFinOps');
    const res = await fn({ tenantId, yearMonth });
    return res.data;
  },

  async submitConversationFeedback(input: OpsCopilotFeedbackInput): Promise<boolean> {
    const fn = httpsCallable<OpsCopilotFeedbackInput, { success: boolean }>(functions, 'submitConversationFeedback');
    const res = await fn(input);
    return res.data.success;
  },
};
